import React, { useEffect } from 'react';

import {
  useSkillsState,
  useSkillsActions,
} from './SkillsContext';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { createUnrecognizedSkill, getSkills } from './restApi';

const NewUnrecognizedSkillForm = () => {
  const state = useSkillsState();
  const { onResponse, onError, updateDebouncedSkillNameForFuzzyFilter, updateNewSkillName } = useSkillsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    const handler = setTimeout(() => {
      updateDebouncedSkillNameForFuzzyFilter(state?.newUnrecognizedSkillForm?.skillName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [state?.newUnrecognizedSkillForm?.skillName]);

  useEffect(() => {
    getSkills({
      onResponse,
      onError,
      pageNumber: 1,
      debouncedSkillNameForFuzzyFilter: state?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
    });
  }, [state?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter]);

  const handleSubmit = () => {
    createUnrecognizedSkill({
      onResponse,
      onError,
      body: {
        newUnrecognizedSkillForm: state?.newUnrecognizedSkillForm,
        authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Skill Name" id="skillName">
        <Input
          type="text"
          placeholder="Search Skill And Add If Not Found..."
          value={state?.newUnrecognizedSkillForm?.skillName}
          onChange={(e) => updateNewSkillName(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button type="submit">Add Skill</Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewUnrecognizedSkillForm;
